import { Username } from './Username'

export { default as translations } from './Username.intl'
export default Username
